export const ANYWHERE_NETWORK = 'Anywhere';
